import React, { useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid, MenuItem, Checkbox, FormControlLabel } from "@material-ui/core";
import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { useDispatch, useSelector } from "react-redux";
import { ValidatorForm, SelectValidator } from "react-material-ui-form-validator";
import { useForm } from "../../../../hooks/useForm";
import { getTiposDocuPresupuesto } from "../../../../actions/autorizaciones/Autorizaciones";


const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
});


export const FormDocumentacionRecupero = (props) => {

    const dispatch = useDispatch();

    const classes = useStyles();
    const { tipoDocumentacion } = props;
    const { itemsTiposDocu } = useSelector(state => state.autorizaciones);


    useEffect(() => {
        dispatch(getTiposDocuPresupuesto());
    }, [dispatch]);

    let tipoDocumentacionDefault = {
        idDocumentacionRecupero: 0,
        idTipoDoc: "",
        obligatorio: false
    }
    const [
        formValues,
        handleInputChange,
        ,
        setearValor,
    ] = useForm(
        tipoDocumentacion !== null ? tipoDocumentacion : tipoDocumentacionDefault
    );

    const handleSave = (e) => {
        e.preventDefault()
        props.handleSave(formValues);
    };

    const handleChangeCheckbox = (e) => {
        setearValor(e.target.name, e.target.checked);
    };

    console.log(tipoDocumentacion)
    console.log(tipoDocumentacionDefault)
    console.log(formValues)

    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>

                <Grid item md={6} style={{ padding: 16 }}>
                    <SelectValidator
                        value={formValues.idTipoDoc}
                        onChange={(e) => {
                            handleInputChange(e);
                        }}
                        disabled={false}
                        label="Tipo de Documentacion"
                        name="idTipoDoc"
                        validators={["required"]}
                        errorMessages={["El tipo es requerido"]}
                        fullWidth
                    >
                        <MenuItem value="">
                            <em>Seleccione</em>
                        </MenuItem>
                        {itemsTiposDocu.map((t) => (
                            <MenuItem key={t.idTipoDoc} value={t.idTipoDoc}>
                                {t.descripcion}
                            </MenuItem>
                        ))}
                    </SelectValidator>
                </Grid>

                <Grid container item xs={6} md={3} justify="center" style={{ padding: 10 }}>
                    <Grid item container justify="left">
                        <FormControlLabel
                            control={
                                <Checkbox
                                    name="obligatorio"
                                    //aria-describedby={sur}
                                    checked={formValues.obligatorio}
                                    onChange={handleChangeCheckbox}
                                />
                            }
                            label="Obligatorio"
                        />
                    </Grid>
                </Grid>


                <Grid container className={classes.botonera} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={props.cerrarModal}
                            >
                                CANCELAR
                            </Button>
                            <Button
                                variant="contained"
                                color="primary"
                                size="small"
                                startIcon={<SaveIcon />}
                                type='submit'
                                style={{ marginLeft: "0.5rem" }}
                                onClick={props.cerrarModal}
                            >
                                GUARDAR
                            </Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    )
}
